import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import actions from "../actions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { EllipsisTooltipText } from "../../common/components/EllipsisTextWithTooltip";
import Loader from "../../common/components/Loader";
import LoadingOverlay from "react-loading-overlay";

const BbiConfigModal = ({
    onCancel,
    heading,
    onSave,
    trade_ids,
    getListParams,
    btnName = "Save",
    isLoading = false,
    simpleNarrativeTextValue = true,
    dynamicBands = {},
    selectedTileData = {},
    filters = null,
    isBsi = false,
    isBbi = false,
    isBai = false,
    viewOnly = false,
    isBuildingBbi = false,
    isSiteBsi = false
}) => {
    const [tradeValues, setTradeValues] = useState([]);
    const [selectedTrades, setSelectedTrades] = useState([]);
    const [simpleNarrativeText, setSimpleNarrativeText] = useState(true);
    const dispatch = useDispatch();
    const { masterFilterList, filterFields } = useSelector(state => state.dashboardReducer);
    const { getBuildingTradeData } = useSelector(state => state?.smartChartReducer);
    const [selectedDynamicFields, setSelectedDynamicFields] = useState({});
    const [displayType, setDisplayType] = useState(selectedTileData?.export_property?.extra_config?.fci?.display_type || "percentage");
    const [exportKeys, setExportKeys] = useState({ bbi_report: true, bsi_report: true, bai_report: true, stop_light_report: false });
    useEffect(() => {
        // const filterDetail = filterFields?.find(({ paramKey }) => paramKey === "trade_ids");
        // const { key, searchKey, getListKey, isBoolean } = filterDetail;
        // let params = {
        //     ...filters,
        //     searchKey,
        //     field: isBoolean ? ["Yes", "No"] : getListKey,
        //     project_ids: getListParams?.project_ids?.[0] || getListParams?.project_id,
        //     client_ids: getListParams?.client_ids?.[0] || getListParams?.client_id,
        //     building_ids: getListParams?.building_ids?.[0] || getListParams?.building_id
        // };
        // dispatch(actions.getMasterFilter(params, key, true));
        let params = {
            project_id: getListParams?.project_ids?.[0] || getListParams?.project_id,
            ...((isBbi || isBuildingBbi) && { building_id: getListParams?.building_ids?.[0] || getListParams?.building_id }),
            ...((isBsi || isSiteBsi) && { site_id: getListParams?.site_ids?.[0] || getListParams?.site_id }),
            ...(isBai && { addition_id: getListParams?.addition_ids?.[0] || getListParams?.addition_id })
        };
        dispatch(actions?.getBuildingTrades(params));
        setExportKeys({
            bbi_report: selectedTileData?.bbi_report,
            bsi_report: selectedTileData?.bsi_report,
            bai_report: selectedTileData?.bai_report,
            stop_light_report: selectedTileData?.stop_light_report
        });
    }, []);
    useEffect(() => {
        if (trade_ids) {
            setSelectedTrades(_.uniq([...selectedTrades, ...trade_ids]));
            setSimpleNarrativeText(simpleNarrativeTextValue);
            setSelectedDynamicFields(selectedTileData?.export_property?.dynamic_field);
            setDisplayType(selectedTileData?.export_property?.extra_config?.fci?.display_type);
        }
    }, [trade_ids]);
    useEffect(() => {
        if (getBuildingTradeData?.list) {
            setTradeValues([
                ...(getBuildingTradeData?.list?.data?.building_trades || [])
                    .map(trade => ({
                        ...trade,
                        isProjectTrade: false
                    }))
                    ?.sort((a, b) => a?.name?.localeCompare(b?.name)),
                ...(getBuildingTradeData?.list?.data?.project_trades || [])
                    .filter(
                        projectTrade =>
                            !(getBuildingTradeData?.list?.data?.building_trades || []).some(buildingTrade => buildingTrade.id === projectTrade.id)
                    )
                    .map(trade => ({
                        ...trade,
                        isProjectTrade: true
                    }))
                    ?.sort((a, b) => a?.name?.localeCompare(b?.name))
            ]);
            if (!trade_ids) {
                setSelectedTrades(_.uniq([...selectedTrades, ...(getBuildingTradeData?.list?.data?.building_trades || [])?.map(e => e.id)]));
            }
        }
    }, [getBuildingTradeData?.list]);
    const handleCheckboxClick = id => {
        setSelectedTrades(prevSelectedTrades => {
            if (prevSelectedTrades.includes(id)) {
                return prevSelectedTrades.filter(tradeId => tradeId !== id);
            } else {
                return [...prevSelectedTrades, id];
            }
        });
    };
    const handleSave = () => {
        onSave(selectedTrades, simpleNarrativeText, { dynamic_field: selectedDynamicFields }, { fci: { display_type: displayType } }, exportKeys);
    };
    const handleCheckboxChange = (group, fieldKey) => {
        setSelectedDynamicFields(prevState => {
            const updatedFields = { ...prevState };

            if (!updatedFields[group]) {
                updatedFields[group] = [];
            }

            if (updatedFields[group].includes(fieldKey)) {
                updatedFields[group] = updatedFields[group].filter(f => f !== fieldKey);
            } else {
                updatedFields[group] = [...updatedFields[group], fieldKey];
            }

            if (updatedFields[group].length === 0) {
                delete updatedFields[group];
            }

            return updatedFields;
        });
    };

    const handleGroupCheckboxChange = (group, fields) => {
        setSelectedDynamicFields(prevState => {
            const updatedFields = { ...prevState };
            const groupFields = fields.map(field => field.field_name);
            if ((updatedFields[group] || []).length === groupFields.length) {
                delete updatedFields[group];
            } else {
                updatedFields[group] = groupFields;
            }

            return updatedFields;
        });
    };
    const handleExportKeyChange = (key, isChecked) => {
        setExportKeys(prevState => ({
            ...prevState,
            [key]: isChecked
        }));
    };
    const projectTradeData = tradeValues?.filter(data => data?.isProjectTrade);

    const handleExportTradeSummaryCheckboxClick = () => {
        const allTradeIds = projectTradeData?.map(data => data.id) || [];

        const allSelected = allTradeIds.every(id => selectedTrades.includes(id));

        if (allSelected) {
            setSelectedTrades(prev => prev.filter(id => !allTradeIds.includes(id)));
        } else {
            setSelectedTrades(prev => [...new Set([...prev, ...allTradeIds])]);
        }
    };

    return (
        <>
            <div className={`modal modal-region smart-chart-popup bbi-pop bbi-build-pop`} id="modalId" tabindex="-1" style={{ display: "block" }}>
                <Draggable handle=".draggable" cancel=".not-draggable">
                    <LoadingOverlay active={getBuildingTradeData?.loading} spinner={<Loader />} fadeSpeed={10}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content outerModal_draggable">
                                <div className="modal-header draggable">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        <div className="txt-hed d-flex align-items-center">
                                            {heading || (isBbi ? "BBI/Stoplight Chart" : isBai ? "BAI" : "BSI/Stoplight Chart")}
                                        </div>
                                    </h5>
                                    <button type="button" className="close" onClick={() => onCancel()}>
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body region-otr draggable">
                                    <div className="upload-area not-draggable">
                                        <div className="category-check-wrap">
                                            {(isBbi || isBsi) && (
                                                <div className="wrapper-bg-bbi">
                                                    <h4>Exports *</h4>
                                                    <div className="categ-wrap-trade">
                                                        <div className="d-flex">
                                                            <div className="formInp d-flex flex-wrap col-md-12 p-0">
                                                                <div className="col-md-4 checkbox-cover">
                                                                    <span className="dropdown-item">
                                                                        <label className="container-check">
                                                                            <EllipsisTooltipText
                                                                                text={`${heading || (isBbi ? "BBI" : "BSI")} Export`}
                                                                            />
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={!!exportKeys[isBbi ? "bbi_report" : "bsi_report"]}
                                                                                onChange={e =>
                                                                                    handleExportKeyChange(
                                                                                        isBbi ? "bbi_report" : "bsi_report",
                                                                                        e.target.checked
                                                                                    )
                                                                                }
                                                                                disabled={viewOnly}
                                                                            />
                                                                            <span className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                        </label>
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-4 checkbox-cover">
                                                                    <span className="dropdown-item">
                                                                        <label className="container-check">
                                                                            <EllipsisTooltipText text={"Stoplight Chart Export"} />
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={!!exportKeys["stop_light_report"]}
                                                                                onChange={e =>
                                                                                    handleExportKeyChange("stop_light_report", e.target.checked)
                                                                                }
                                                                                disabled={viewOnly}
                                                                            />
                                                                            <span className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                        </label>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <>
                                                <div className="wrapper-bg-bbi">
                                                    <h4 className="d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                                                        <span className="mr-2">Trades</span>
                                                        {projectTradeData?.length > 0 && (
                                                            <div style={{ marginLeft: "auto" }}>
                                                                <label className="container-check mb-0" style={{ fontSize: "14px" }}>
                                                                    Export Trade Summary even if No Recommendations
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={projectTradeData?.every(trade => selectedTrades.includes(trade.id))}
                                                                        onClick={() => handleExportTradeSummaryCheckboxClick()}
                                                                        disabled={viewOnly}
                                                                    />
                                                                    <span
                                                                        className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}
                                                                        style={{ height: "20px", width: "20px" }}
                                                                    ></span>
                                                                </label>
                                                            </div>
                                                        )}
                                                    </h4>

                                                    <div className="categ-wrap-trade">
                                                        <div className="d-flex">
                                                            <div className="formInp d-flex flex-wrap col-md-12 p-0">
                                                                {tradeValues?.map((value, index) => (
                                                                    <div className="col-md-4 checkbox-cover" key={index}>
                                                                        <span className="dropdown-item">
                                                                            <label className="container-check">
                                                                                <EllipsisTooltipText
                                                                                    text={value?.name}
                                                                                    className="overflow-txt-bbi"
                                                                                />
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedTrades.includes(value?.id)}
                                                                                    onClick={() => handleCheckboxClick(value?.id)}
                                                                                    disabled={viewOnly}
                                                                                />
                                                                                <span
                                                                                    className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                ></span>
                                                                            </label>
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="wrapper-bg-bbi">
                                                    <h4 style={{ textTransform: "capitalize" }}>Executive Summary</h4>
                                                    <div class="categ-wrap-trade ">
                                                        <div className="formInp d-flex">
                                                            <div className="col-md-4 checkbox-cover">
                                                                <span className="dropdown-item">
                                                                    <label className="container-check">
                                                                        Simple Text
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={simpleNarrativeText}
                                                                            onChange={e => setSimpleNarrativeText(true)}
                                                                            disabled={viewOnly}
                                                                        />
                                                                        <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                            <div className="col-md-4 checkbox-cover">
                                                                <span className="dropdown-item">
                                                                    <label className="container-check">
                                                                        Rich Text
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={!simpleNarrativeText}
                                                                            onChange={e => setSimpleNarrativeText(false)}
                                                                            disabled={viewOnly}
                                                                        />
                                                                        <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="wrapper-bg-bbi">
                                                    <h4 style={{ textTransform: "capitalize" }}>FCI</h4>
                                                    <div className="categ-wrap-trade">
                                                        <div className="formInp d-flex">
                                                            <div className="col-md-4 checkbox-cover">
                                                                <span className="dropdown-item">
                                                                    <label className="container-check">
                                                                        Percentage
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={displayType === "percentage"}
                                                                            onChange={() => setDisplayType("percentage")}
                                                                            disabled={viewOnly}
                                                                        />
                                                                        <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                            <div className="col-md-4 checkbox-cover">
                                                                <span className="dropdown-item">
                                                                    <label className="container-check">
                                                                        Decimal
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={displayType === "text"}
                                                                            onChange={() => setDisplayType("text")}
                                                                            disabled={viewOnly}
                                                                        />
                                                                        <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {!isBsi &&
                                                    !isBai &&
                                                    Object.entries(dynamicBands || {})?.map(([groupKey, fields]) => {
                                                        const allFieldsSelected =
                                                            (selectedDynamicFields?.[groupKey] || [])?.length === fields?.length;
                                                        return (
                                                            <div className="wrapper-bg-bbi">
                                                                <h4 style={{ textTransform: "capitalize" }}>
                                                                    {" "}
                                                                    <div className="formInp dyna-fld">
                                                                        <div className="col-md-12 checkbox-cover">
                                                                            <span className="dropdown-item">
                                                                                <label className="container-check header-txt">
                                                                                    {groupKey}
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={allFieldsSelected}
                                                                                        onChange={() => handleGroupCheckboxChange(groupKey, fields)}
                                                                                        disabled={viewOnly}
                                                                                    />
                                                                                    <span
                                                                                        class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                    ></span>
                                                                                </label>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </h4>
                                                                <div className="categ-wrap-trade">
                                                                    <div className="formInp d-flex flex-wrap">
                                                                        {fields.map(field => (
                                                                            <div key={field.field_name} className="col-md-3 checkbox-cover">
                                                                                <span className="dropdown-item">
                                                                                    <label className="container-check">
                                                                                        <EllipsisTooltipText
                                                                                            text={field?.label}
                                                                                            className="overflow-txt-bbi"
                                                                                        />
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={
                                                                                                (selectedDynamicFields?.[groupKey] || [])?.includes(
                                                                                                    field.field_name
                                                                                                ) || false
                                                                                            }
                                                                                            onChange={() =>
                                                                                                handleCheckboxChange(groupKey, field.field_name)
                                                                                            }
                                                                                            disabled={viewOnly}
                                                                                        />
                                                                                        <span
                                                                                            class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                        ></span>
                                                                                    </label>
                                                                                </span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </>
                                        </div>
                                    </div>

                                    {!viewOnly && (
                                        <div className="btn-sec not-draggable">
                                            <div className="text-right btnOtr edit-cmn-btn mt-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary btnClr col-md-2 mr-3"
                                                    data-dismiss="modal"
                                                    onClick={() => onCancel()}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btnRgion col-md-2"
                                                    onClick={() => handleSave()}
                                                    disabled={
                                                        isLoading || ((isBbi || isBsi) && !Object.values(exportKeys).some(value => value === true))
                                                    }
                                                >
                                                    {btnName}
                                                    {isLoading && (
                                                        <span className="edit-icn-bx icon-btn-sec cursor-disabled ml-2">
                                                            <div className="spinner-border text-white" role="status">
                                                                <span className="sr-only">Loading...</span>
                                                            </div>
                                                        </span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </LoadingOverlay>
                </Draggable>
            </div>
        </>
    );
};

export default BbiConfigModal;
